import type {PropsWithChildren} from "react";
import {QueryClientProvider} from "@tanstack/react-query";
import {queryClient} from "./trpc";

export const AppProviders = ({children}: PropsWithChildren) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
